module.exports = __webpack_public_path__ + "img/seckill.3233500b.png";